export const StorageManager = {
    autosave: true,
    autoload: true,
};